import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import EducationCategoryCard from '@components/molecules/education/category-card/educationCategoryCard';
import EducationArrowLink from '@components/atoms/education/arrow-link/educationArrowLink';
import { AngleDown } from '@components/icons/arrow/arrow';
import { Swiper, SwiperSlide } from 'swiper/react';
import Headline from '../../../atoms/headline/headline';
import MixedCopy from '../../../molecules/mixed-copy/mixedCopy';
import Container from '../../../layout/container/container';
import StyledEducationCategoryTeaser from './educationCategoryTeaser.style';

import 'swiper/css';

const content = [
  {
    id: 1,
    name: 'agriculture',
    title: 'Landwirtschaft'
  },
  {
    id: 2,
    name: 'ressources',
    title: 'Rohstoffe'
  },
  {
    id: 3,
    name: 'city',
    title: 'Städte'
  },
  {
    id: 4,
    name: 'nutrition',
    title: 'Ernährung'
  },
  {
    id: 5,
    name: 'health',
    title: 'Gesundheit'
  },
  {
    id: 6,
    name: 'mobility',
    title: 'Mobilität'
  },
  {
    id: 7,
    name: 'energy',
    title: 'Energie'
  },
  {
    id: 8,
    name: 'work',
    title: 'Arbeit'
  },
  {
    id: 9,
    name: 'democracy',
    title: 'Demokratie'
  }
];

function EducationCategoryTeaser({
  onlyTopics = false,
  filter = false,
  topicFiltering,
  setTopicFiltering,
  topicTexts = []
}) {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 940);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const swiperSettings = {
    slidesPerView: 2,
    spaceBetween: 15,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      390: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      640: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    }
  };

  return (
    <StyledEducationCategoryTeaser>
      {isMobile && !onlyTopics && (
        <Container>
          <div className="category-teaser__select-topic">
            <Headline>Select a Topic</Headline>
            <AngleDown />
          </div>
        </Container>
      )}
      <div className="category-teaser__grid">
        {isMobile ? (
          <Swiper {...swiperSettings}>
            {content.map((item, index) => (
              <SwiperSlide key={item.id}>
                <EducationCategoryCard
                  category={item.name}
                  slug={item.name}
                  title={item.title}
                  index={index}
                  filter={filter}
                  setTopicFiltering={setTopicFiltering}
                  topicFiltering={topicFiltering}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <>
            {content.map((item, index) => (
              <EducationCategoryCard
                key={item.id}
                category={item.name}
                slug={item.name}
                title={item.title}
                index={index}
                filter={filter}
                setTopicFiltering={setTopicFiltering}
                topicFiltering={topicFiltering}
              />
            ))}
          </>
        )}
      </div>

      {content.map(
        (item, i) =>
          item.name === topicFiltering &&
          (topicTexts[i]?.subline || topicTexts[i]?.introCopy) && (
            <Container key={i} className="category-teaser__topic-texts">
              {topicTexts[i].subline && <Headline>{topicTexts[i].subline}</Headline>}
              {topicTexts[i].introCopy && <MixedCopy fullWidth html={topicTexts[i].introCopy} />}
            </Container>
          )
      )}

      {!onlyTopics && (
        <Container className="category-teaser__link-container">
          <EducationArrowLink href="/de/bildung/bibliothek" />
        </Container>
      )}
    </StyledEducationCategoryTeaser>
  );
}

EducationCategoryTeaser.propTypes = {
  onlyTopics: PropTypes.bool,
  filter: PropTypes.bool,
  topicFiltering: PropTypes.string,
  setTopicFiltering: PropTypes.func,
  topicTexts: PropTypes.shape({
    subline: PropTypes.string,
    introCopy: PropTypes.string
  })
};

export default EducationCategoryTeaser;
